import { render } from "./NewExtraService.vue?vue&type=template&id=19ca36ce"
import script from "./NewExtraService.vue?vue&type=script&lang=js"
export * from "./NewExtraService.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__